import * as React from 'react';
import { OfficesScheme } from '../../settings/officesScheme';
import styles from './Offices.css';
import { Image, UIHeading1, UIText1 } from '@cian/ui-kit';
import { Factoid } from './internal/components/Factoid';
import { Layout } from '../Layout';

type OfficesProps = {
  scheme: OfficesScheme;
};

export const Offices: React.FC<OfficesProps> = props => {
  const {
    scheme: { photos, avatar, disclaimer, factoids, description, title, moreInfo },
  } = props;

  return (
    <Layout>
      <section data-testid="Offices-block" className={styles['container']}>
        <UIHeading1>{title}</UIHeading1>
        <div className={styles['content']}>
          <div className={styles['avatar-wrapper']}>
            <Image src={avatar.url} height={avatar.height} width={avatar.width} />
          </div>
          <div className={styles['main-info-container']}>
            <div className={styles['disclaimer-container']}>
              <div className={styles['disclaimer-wrapper']}>
                <UIText1 color="current_color">{disclaimer}</UIText1>
              </div>
              <div className={styles['factoids-container']}>
                {factoids.map(factoid => {
                  return <Factoid key={factoid.id} title={factoid.title} subtitle={factoid.subtitle} />;
                })}
              </div>
            </div>
            <div className={styles['description-container']}>
              {description.map((item, index) => {
                return (
                  <UIText1 color="current_color" key={index}>
                    {item}
                  </UIText1>
                );
              })}
            </div>
          </div>
          <div className={styles['photos-wrapper']}>
            {photos.map(photo => {
              return (
                <div key={photo.id} style={{ backgroundImage: `url(${photo.url})` }} className={styles['photo']}>
                  <span className={styles['photo-title']}>{photo.title}</span>
                </div>
              );
            })}
          </div>
          <div className={styles['more-info-wrapper']}>
            <UIText1 color="current_color">{moreInfo}</UIText1>
          </div>
        </div>
      </section>
    </Layout>
  );
};
